import type { CollapseProps } from "antd";

import GeneralInfo from "./Info";
import ForceUpdateSettings from "./ForceUpdateSettings";


export const MobileAppVersionConstants = {
	GENERAL_INFO: "Genel Bilgiler",
	FORCE_UPDATE: "Zorunlu Güncelleme Ayarları"
};

export const MobileAppVersionItems: CollapseProps["items"] = [
	{
		key: "1",
		label: MobileAppVersionConstants.GENERAL_INFO,
		children: <GeneralInfo />,
	},
	{
		key: "2",
		label: MobileAppVersionConstants.FORCE_UPDATE,
		children: <ForceUpdateSettings />,
	}
];
